import * as Yup from 'yup'

export const InstanceNameSchema = Yup.object().shape({
  newName: Yup.string().trim().ensure().required('The instance name is required.'),
})
